<div class="container mt-3 mb-4">
    <div class="row justify-content-center">
        <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
            <iframe *ngIf="iframeSrc" id="form1" [src]="iframeSrc" allow="payment" style="border:0;width:100%;" title="Weather Widget"
                height="1284"></iframe>
        </div>
    </div>
</div>